import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import retreat from "../assets/Retreat.jpeg";
import hackathon from "../assets/Hackathon.jpeg";
import collaberation from "../assets/collaboration.jpeg";
import wibes from "../assets/wibes.jpeg";
import emailjs from "emailjs-com";
import "./Career.css";
import { jobs } from "../data/jobsData"
import { FaChevronDown } from "react-icons/fa";
import {
  FaUsers,
  FaChevronUp,
  FaGlobe,
  FaAward,
  FaShieldAlt,
  FaBalanceScale,
  FaChartLine,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Career = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const [formData, setFormData] = useState({
  name: "",
  email: "",
  linkedin: "",
  role: "",
  message: "",
});

const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  if (
    !formData.name ||
    !formData.email ||
    !formData.role ||
    !formData.message
  ) {
    setStatus("Please fill all required fields.");
    return;
  }

  const templateParams = {
    to_email: "klyzenventures@gmail.com",

    name: formData.name,
    from_name: formData.name,
    from_email: formData.email,
    linkedin: formData.linkedin,
    role: formData.role,
    message: formData.message,
  };

  emailjs
    .send(
      "service_tlo4b0p",
      "template_17cfpju",
      templateParams,
      "Xs45r19lV9h_EUOZO"
    )
    .then(
      () => {
        setStatus("Application Submitted Successfully!");

        setFormData({
          name: "",
          email: "",
          linkedin: "",
          role: "",
          message: "",
        });
      },
      (err) => {
        setStatus("Failed to submit application.");
        console.error(err);
      }
    );
};
  return (

    <>
      <Navbar />
      <div className="career-page">

        {/* Hero Section */}
        <section className="career-hero">
          <div className="overlay">
            <h1>
              Join Our <span>Team</span>
            </h1>

            <p>
              Shape the future with us. Grow, learn, and make an impact in a collaborative, innovative environment
            </p>

          </div>
        </section>

        {/* Why Work With Us */}

        <section className="why-work">
          <h2>Why Work With Us</h2>

          <div className="benefits-grid">

            <div className="card">
              <div className="card-header">
                <FaUsers />
                <h3>Collaborative Culture</h3>
              </div>
              <p>Work with passionate and talented people in a supportive environment.</p>
            </div>

            <div className="card">
              <div className="card-header">
                <FaChartLine />
                <h3>Growth & Learning</h3>
              </div>
              <p>Continuous learning, mentorship, and career advancement.</p>
            </div>

            <div className="card">
              <div className="card-header">

                <FaGlobe />
                <h3>Global Impact</h3>
              </div>
              <p>Build solutions used by clients worldwide.</p>
            </div>

            <div className="card">
              <div className="card-header">

                <FaAward />
                <h3>Recognition</h3>
              </div>
              <p>We celebrate achievements and reward excellence.</p>
            </div>

            <div className="card">
              <div className="card-header">

                <FaShieldAlt />
                <h3>Security & Trust</h3>
              </div>
              <p>Integrity, transparency and safe workplace.</p>
            </div>

            <div className="card">
              <div className="card-header">

                <FaBalanceScale />
                <h3>Work-Life Balance</h3>
              </div>
              <p>Flexible hours,remote option and wellness supportive.</p>
            </div>

          </div>
        </section>
        

        {/* Open Positions */}


        <section className="jobs-wrapper">
          <section className="jobs-section">
            <h2>Open Positions</h2>

            {jobs.map((job, index) => (
              <div className="job-card" key={index}>

                <div
                  className="job-header"
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <h3>{job.title}</h3>

                  <div className="job-details">

                    <span className="job-type">
                      {job.type}
                    </span>

                    <p className="job-location">
                      <FaMapMarkerAlt />
                      {job.location}
                    </p>

                    {openIndex === index ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}

                  </div>
                </div>

                {openIndex === index && (
                  <div className="job-content">

                    <p>{job.description}</p>

                    <h4>Key Responsibilities</h4>

                    <ul>
                      {job.responsibilities.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>

                    <h4>Requirements</h4>

                    <ul>
                      {job.requirements.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>

                    <h4>Preferred Qualifications</h4>

                    <ul>
                      {job.preferredQualifications.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>

                    <div className="apply-btn-container">
                      <button className="apply-btn">
                        Apply Now
                      </button>
                    </div>

                  </div>
                )}
              </div>
            ))}
          </section>
        </section>



        {/* Life At Klyzen */}

        <section className="life-section">

          <h2>Life At Klyzen Venture</h2>

          <div className="gallery">

            <div className="gallery-card">
              <img src={retreat} alt="Team Retreat" />
              <h4>Team Events</h4>
            </div>

            <div className="gallery-card">
              <img src={hackathon} alt="Hackathon winners" />
              <h4>Hackathon Winners</h4>
            </div>

            <div className="gallery-card">
              <img src={wibes} alt="Workspace Wibes" />
              <h4>Workspace wibes</h4>
            </div>

            <div className="gallery-card">
              <img src={collaberation} alt="Collaboration In Action" />
              <h4>Collaberation in Action</h4>
            </div>

          </div>

        </section>


        {/* Apply Form */}


        <section className="apply-section">
          <div className="apply-box">
            <h2>Apply Now</h2>

            <form className="apply-form" onSubmit={handleSubmit}>


             <input
  type="text"
  name="name"
  placeholder="Full Name"
  value={formData.name}
  onChange={handleChange}
  required
/>

              <input
  type="email"
  name="email"
  placeholder="Email Address"
  value={formData.email}
  onChange={handleChange}
  required
/>
             <input
  type="text"
  name="linkedin"
  placeholder="LinkedIn Profile URL"
  value={formData.linkedin}
  onChange={handleChange}
/>
             
             <select
  name="role"
  value={formData.role}
  onChange={handleChange}
  required
>
                <option value="">Select Role</option>
                <option>Senior Sales Manager</option>
                <option>Sales Executive</option>
                <option>Backend Engineer</option>
                <option>DevOps Specialist</option>
              </select>
 
               <div className="resume-field">
                 <label>Resume (PDF, max 2MB)</label>
                 <input type="file" />
              </div> 

          
            <textarea
  rows="4"
  name="message"
  placeholder="Tell us why you're a great fit..."
  value={formData.message}
  onChange={handleChange}
  required
/>

              <button type="submit">
                Submit Application
              </button>
              {status && <p className="form-status">{status}</p>}

            </form>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Career;